<template>
  <section-page
    title="Steps"
  >
    <template v-slot:right>
      <filter-button-add @click="createStep">
        New Step
      </filter-button-add>
    </template>

    <app-loading-section
      :loading="isLoading"
      :count="steps.length"
      heading="There are no steps"
    >
      <table-draggable
        :table-data="steps"
        @updated="sortOrder"
      >
        <b-table-column label="No." field="sort_order" width="70" v-slot="props">
          <icon-default
            icon="sort"
            size="is-small"
            color="is-link"
          ></icon-default>
          {{ props.index + 1 }}.
        </b-table-column>

        <b-table-column label="Statement" field="statement" v-slot="props">
          {{ $utils.truncateString(props.row.statement, 125).replace( /(<([^>]+)>)/ig, '') }}
        </b-table-column>

        <b-table-column label="Fields" field="fields" width="220" v-slot="props">
          <span v-for="(field, index) in props.row.fields" :key="index">
            {{ field.displayLabel }} <br>
          </span>
        </b-table-column>

        <b-table-column cell-class="action_cell" width="100" v-slot="props">
          <button-link @click="editStep(props.row)">Manage</button-link>
        </b-table-column>
      </table-draggable>
    </app-loading-section>

    <modal-container>
      <modal-crud-form
        ref="callScriptStepModal"
        title="Call Script Step"
        :collection.sync="steps"
        form-component="call-script-step-form"
        :is-wide="true"
      ></modal-crud-form>
    </modal-container>
  </section-page>
</template>

<script>
export default {
  name: "CallScriptSteps",
  props: {
    callScriptId: {
      type: Number,
      required: true
    },
    callScriptType: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      isLoading: true,
      steps: [],
      stepFieldsData: [],
    }
  },
  created() {
    this.getSteps();
    this.getStepFieldsData();
  },
  computed: {
    stepFields() {
      let fields = [];
      this.steps.forEach(step => {
        fields.push(step.fields)
      })

      return fields.flat();
    },
  },
  methods: {
    getSteps() {
      this.$api.callScripts.get(this.callScriptId)
        .then(res => {
          this.steps = res.data.steps;
          this.isLoading = false;
        });
    },
    getStepFieldsData() {
      this.$api.callScriptSteps.getFields(this.callScriptType)
        .then(res => {
          let fields = [];
          let data = res.data;

          for (let parentProp in data) {
            for (let prop in data[parentProp]) {
              fields.push({displayLabel: `${parentProp} - ${prop}`, ...data[parentProp][prop]})
            }
          }

          this.stepFieldsData = fields
        });
    },
    createStep() {
      this.$refs.callScriptStepModal.open({
        call_script_id: this.callScriptId,
        step_fields: this.stepFields,
        step_fields_data: this.stepFieldsData
      });
    },
    editStep(step) {
      this.$refs.callScriptStepModal.open({
        ...step,
        step_fields: this.stepFields,
        step_fields_data: this.stepFieldsData
      });
    },
    sortOrder(data) {
      let ids = data.map((row) => { return row.id });

      this.$api.callScriptSteps.updateSequence({ids: ids})
        .then(() => {
          this.$buefy.toast.open({
            message: 'Changes on steps sequence were saved.',
            type: 'is-success'
          });
        });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

</style>
